import type { ProductBrief } from "../types/product";
export const productBrief: ProductBrief = {
  "brand": "Team Communication Ready",
  "fullTitle": "Team Communication Ready - Volume 1: Everyday Team Communication",
  "positioning": {
    "headline": "Your next team communication workshops. Already planned for you.",
    "lead": "Five complete 30-minute workshop plans with scripts, role cards, model conversations and feedback sheets.",
    "buyer": "Team leaders, internal facilitators and small-business owners training 3-12 coworkers.",
    "teaches": "Everyday communication between coworkers.",
    "notFor": [
      "Sales training",
      "Manager performance reviews",
      "Customer-service complaint handling"
    ],
    "promise": "Ready-planned team communication workshops with the materials already written.",
    "doesNotPromise": [
      "Guaranteed team performance",
      "Zero preparation",
      "Certification"
    ]
  },
  "price": {
    "amountUsd": 27,
    "currency": "USD",
    "billing": "one-time",
    "subscription": false
  },
  "coreManual": {
    "volumes": [
      {
        "number": 1,
        "label": "Volume 1",
        "workshops": "Workshops 1-5"
      }
    ],
    "note": "Volume 1 and all five bonus PDFs are included in the $27 one-time offer."
  },
  "workshopContents": [
    "Timed 30-minute facilitator plan",
    "Exact facilitator scripts",
    "Two fictional workplace cases",
    "Speaker, listener and observer role cards",
    "Model dialogues and observation sheets",
    "One real-work application action"
  ],
  "caseNote": "Use Case A for the timed session. Case B is an alternative or a separate repeat.",
  "format": {
    "language": "English",
    "deliverables": [
      "Volume 1 facilitator manual (PDF)",
      "Printable participant materials",
      "Five bonus PDFs"
    ],
    "notIncluded": [
      "Video",
      "Slides",
      "Editable templates",
      "Software",
      "Certification",
      "Resale rights"
    ],
    "usage": "Internal-team use only."
  },
  "status": "Pay securely through the Impul checkout.",
  "sessionFlow": [
    {
      "label": "Opening",
      "minutes": 3
    },
    {
      "label": "Demonstration",
      "minutes": 5
    },
    {
      "label": "Role rotations",
      "minutes": 15
    },
    {
      "label": "Debrief",
      "minutes": 5
    },
    {
      "label": "Application",
      "minutes": 2
    }
  ],
  "workshops": [
    {
      "number": 1,
      "volume": 1,
      "title": "Clear Requests",
      "outcome": "Make a request that names the outcome, owner, deadline and confirmation."
    },
    {
      "number": 2,
      "volume": 1,
      "title": "Listening and Checking Understanding",
      "outcome": "Listen, paraphrase the intended meaning and confirm one unclear detail before acting."
    },
    {
      "number": 3,
      "volume": 1,
      "title": "Useful Status Updates",
      "outcome": "Give a concise update that separates completed work, what remains, the next action and any decision needed."
    },
    {
      "number": 4,
      "volume": 1,
      "title": "Clear Work Handoffs",
      "outcome": "Transfer a task with its current state, next action, owner, deadline and confirmation."
    },
    {
      "number": 5,
      "volume": 1,
      "title": "Clearing Up Everyday Misunderstandings",
      "outcome": "Describe an observable mismatch, check the other person's understanding and agree on a practical next step."
    }
  ],
  "bonuses": [
    {
      "number": 1,
      "title": "The 5-Week Team Communication Practice Calendar",
      "description": "A complete five-week schedule for the five core workshops, with midweek huddles and follow-through checks.",
      "scopeNote": "A schedule for the five core workshops"
    },
    {
      "number": 2,
      "title": "15 Five-Minute Communication Huddles",
      "description": "Fifteen five-minute activities, each with a prompt, task, model response, timing and observation check.",
      "scopeNote": "15 complete short reinforcement activities"
    },
    {
      "number": 3,
      "title": "The Team Communication Needs & Skill Check Kit",
      "description": "Five practical skill checks and a workshop chooser to help you select the next focus for your team.",
      "scopeNote": "A practice-planning aid, not an employee rating"
    },
    {
      "number": 4,
      "title": "The Workshop Invitation & Reminder Pack",
      "description": "Copy-ready invitations, reminders, rescheduling messages and follow-up notes. Fill in the logistics and send.",
      "scopeNote": "Only dates, times and locations to fill in"
    },
    {
      "number": 5,
      "title": "The Team Communication Facilitator Rescue Kit",
      "description": "Exact responses and fallback activities for silence, awkward role-plays, dominant voices, time pressure and more.",
      "scopeNote": "For common facilitation moments"
    }
  ],
  "optionalExtensions": []
};
